import { motion } from 'framer-motion';

const products = [
  {
    title: 'Professional indemnity',
    description:
      'This provides you financial protection from alleged negligence or failure to deliver a service as promised.',
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 6V5C6 3.34315 7.34315 2 9 2H11C12.6569 2 14 3.34315 14 5V6H16C17.1046 6 18 6.89543 18 8V11.5708C15.5096 12.4947 12.8149 12.9999 10 12.9999C7.18514 12.9999 4.49037 12.4947 2 11.5707V8C2 6.89543 2.89543 6 4 6H6ZM8 5C8 4.44772 8.44772 4 9 4H11C11.5523 4 12 4.44772 12 5V6H8V5ZM9 10C9 9.44772 9.44772 9 10 9H10.01C10.5623 9 11.01 9.44772 11.01 10C11.01 10.5523 10.5623 11 10.01 11H10C9.44772 11 9 10.5523 9 10Z"
          fill="#0E35D1"
        />
        <path
          d="M2 13.6923V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V13.6923C15.4872 14.5404 12.7964 14.9999 10 14.9999C7.20363 14.9999 4.51279 14.5404 2 13.6923Z"
          fill="#0E35D1"
        />
      </svg>
    ),
  },
  {
    title: 'Public liability',
    description:
      'Protects you from any injury to clients or third parties or damage to their property caused by you, or your alleged negligence.',
    icon: (
      <svg
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_12096_122216)">
          <path
            d="M7.79637 3.29445C7.79637 4.86195 6.52574 6.13133 4.95699 6.13133C3.38949 6.13133 2.12012 4.86195 2.12012 3.29445C2.12012 1.7257 3.38949 0.455078 4.95699 0.455078C6.52574 0.455703 7.79637 1.72633 7.79637 3.29445Z"
            fill="#0E35D1"
          />
          <path
            d="M20.1892 11.4367C20.1148 11.3404 20.0561 11.2904 20.0561 11.2904C17.8111 9.20045 15.1742 9.2067 13.1686 9.6867C11.8405 9.1192 10.8092 8.41232 10.0411 7.75795C11.6973 6.65107 12.408 5.00545 12.7986 3.64795C12.818 3.57857 12.873 3.36857 12.873 3.36857C12.923 3.0892 13.0217 2.10607 12.038 1.75982C10.8855 1.35482 10.5086 2.6167 10.5086 2.6167C10.4817 2.7142 10.4648 2.81232 10.4355 2.90357C9.86795 4.77482 8.90733 5.72232 7.17858 6.13482C3.48358 7.01982 1.88795 8.92295 1.24233 10.0654C1.19608 10.1498 0.896703 10.6442 0.799203 11.0886C0.719828 11.4404 0.711078 12.2886 1.59608 12.6386C2.4992 12.9961 2.95108 12.2861 3.09858 11.9779C3.1367 11.8973 3.20358 11.7398 3.25733 11.6298C3.4492 11.2467 4.00795 10.3698 5.38608 9.6142C6.39295 10.8129 8.21795 12.5929 10.9998 13.8967C12.1461 14.6486 14.1211 16.2304 14.2886 18.2923C14.2886 18.2923 14.3267 18.5192 14.3511 18.5892C14.4817 18.9836 14.8342 19.6404 15.7098 19.5342C16.4436 19.4448 16.6923 18.9223 16.7742 18.5136C16.8048 18.3473 16.8192 18.1998 16.818 18.1073C16.6117 15.5679 14.9736 13.6617 13.5161 12.4492C14.9773 12.0511 16.9111 11.9536 18.4405 13.3854C18.4405 13.3854 18.5492 13.4586 18.5698 13.4723C18.8786 13.6836 19.6342 14.0617 20.2542 13.2736C20.8655 12.4973 20.4298 11.7492 20.1892 11.4367Z"
            fill="#0E35D1"
          />
        </g>
        <defs>
          <clipPath id="clip0_12096_122216">
            <rect
              width="20"
              height="20"
              fill="white"
              transform="translate(0.666504)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    title: 'Employers liability',
    description:
      'Covers you when you have staff and they are injured in the course of business for which you are alleged negligent.',
    icon: (
      <svg
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.3335 4C4.3335 2.89543 5.22893 2 6.3335 2H14.3335C15.4381 2 16.3335 2.89543 16.3335 4V16C16.8858 16 17.3335 16.4477 17.3335 17C17.3335 17.5523 16.8858 18 16.3335 18H13.3335C12.7812 18 12.3335 17.5523 12.3335 17V15C12.3335 14.4477 11.8858 14 11.3335 14H9.3335C8.78121 14 8.3335 14.4477 8.3335 15V17C8.3335 17.5523 7.88578 18 7.3335 18H4.3335C3.78121 18 3.3335 17.5523 3.3335 17C3.3335 16.4477 3.78121 16 4.3335 16V4ZM7.3335 5H9.3335V7H7.3335V5ZM9.3335 9H7.3335V11H9.3335V9ZM11.3335 5H13.3335V7H11.3335V5ZM13.3335 9H11.3335V11H13.3335V9Z"
          fill="#0E35D1"
        />
      </svg>
    ),
  },
  {
    title: 'Directors and office',
    description:
      'Referred to as D&O, covers individuals who are in senior leadership or board members who could be personally pursued for their actions whilst serving the business.',
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 5.625V7.55625C14.8191 7.51869 14.6348 7.49984 14.45 7.5H5.55C5.36522 7.49984 5.18092 7.51869 5 7.55625V5.625C5 4.46468 5.46094 3.35188 6.28141 2.53141C7.10188 1.71094 8.21468 1.25 9.375 1.25H10.625C11.7853 1.25 12.8981 1.71094 13.7186 2.53141C14.5391 3.35188 15 4.46468 15 5.625Z"
          fill="#0E35D1"
        />
        <path
          d="M14.3063 15.1312C14.1343 15.0431 13.9434 14.9981 13.7501 15C13.4796 15 13.2165 15.0877 13.0001 15.25C12.9419 15.1724 12.8664 15.1094 12.7796 15.066C12.6928 15.0226 12.5971 15 12.5001 15H7.5001C7.40307 15 7.30737 15.0226 7.22059 15.066C7.13381 15.1094 7.05831 15.1724 7.0001 15.25C6.78373 15.0877 6.52056 15 6.2501 15C6.05679 14.9981 5.8659 15.0431 5.69385 15.1312C5.80203 14.7349 6.03737 14.3851 6.3637 14.1356C6.69003 13.886 7.08929 13.7506 7.5001 13.75H9.3751V12.5H10.6251V13.75H12.5001C12.9109 13.7506 13.3102 13.886 13.6365 14.1356C13.9628 14.3851 14.1982 14.7349 14.3063 15.1312Z"
          fill="#0E35D1"
        />
        <path
          d="M16.25 10.55V10.7C16.25 10.9364 16.2034 11.1704 16.113 11.3888C16.0225 11.6072 15.8899 11.8056 15.7228 11.9728C15.5556 12.1399 15.3572 12.2725 15.1388 12.363C14.9204 12.4534 14.6864 12.5 14.45 12.5H5.55C5.31362 12.5 5.07956 12.4534 4.86117 12.363C4.64278 12.2725 4.44435 12.1399 4.27721 11.9728C3.93964 11.6352 3.75 11.1774 3.75 10.7V10.55C3.7503 10.169 3.87149 9.79792 4.09611 9.49018C4.32074 9.18244 4.63722 8.95392 5 8.8375C5.17759 8.77958 5.3632 8.75004 5.55 8.75H14.45C14.6368 8.75004 14.8224 8.77958 15 8.8375C15.3628 8.95392 15.6793 9.18244 15.9039 9.49018C16.1285 9.79792 16.2497 10.169 16.25 10.55ZM7.5 16.25V17.5C7.5 17.8315 7.3683 18.1495 7.13388 18.3839C6.89946 18.6183 6.58152 18.75 6.25 18.75C5.91848 18.75 5.60054 18.6183 5.36612 18.3839C5.1317 18.1495 5 17.8315 5 17.5V16.25C5.00012 16.0174 5.06512 15.7895 5.18767 15.5919C5.31023 15.3943 5.48549 15.2347 5.69375 15.1312C5.8658 15.0431 6.05669 14.9981 6.25 15C6.58152 15 6.89946 15.1317 7.13388 15.3661C7.3683 15.6005 7.5 15.9185 7.5 16.25ZM15 16.25V17.5C15 17.8315 14.8683 18.1495 14.6339 18.3839C14.3995 18.6183 14.0815 18.75 13.75 18.75C13.4185 18.75 13.1005 18.6183 12.8661 18.3839C12.6317 18.1495 12.5 17.8315 12.5 17.5V16.25C12.5 15.9185 12.6317 15.6005 12.8661 15.3661C13.1005 15.1317 13.4185 15 13.75 15C13.9433 14.9981 14.1342 15.0431 14.3062 15.1312C14.5145 15.2347 14.6898 15.3943 14.8123 15.5919C14.9349 15.7895 14.9999 16.0174 15 16.25Z"
          fill="#0E35D1"
        />
      </svg>
    ),
  },
  {
    title: 'Cyber security',
    description:
      'Will help protect you in the event of a malicious attack on your systems or data. Also assists in minimising disruption to your business and covers financial costs involved in recovering from a cyber attack.',
    icon: (
      <svg
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.1665 4.375C12.8213 4.375 12.5415 4.09518 12.5415 3.75V1.875C12.5415 1.52983 12.8213 1.25 13.1665 1.25C13.5117 1.25 13.7915 1.52983 13.7915 1.875V3.75C13.7915 4.09518 13.5117 4.375 13.1665 4.375ZM8.1665 4.375C7.82132 4.375 7.5415 4.09518 7.5415 3.75V1.875C7.5415 1.52983 7.82132 1.25 8.1665 1.25C8.51169 1.25 8.7915 1.52983 8.7915 1.875V3.75C8.7915 4.09518 8.51169 4.375 8.1665 4.375ZM13.1665 18.75C12.8213 18.75 12.5415 18.4702 12.5415 18.125V16.25C12.5415 15.9048 12.8213 15.625 13.1665 15.625C13.5117 15.625 13.7915 15.9048 13.7915 16.25V18.125C13.7915 18.4702 13.5117 18.75 13.1665 18.75ZM8.1665 18.75C7.82132 18.75 7.5415 18.4702 7.5415 18.125V16.25C7.5415 15.9048 7.82132 15.625 8.1665 15.625C8.51169 15.625 8.7915 15.9048 8.7915 16.25V18.125C8.7915 18.4702 8.51169 18.75 8.1665 18.75ZM1.9165 12.5C1.9165 12.1548 2.19633 11.875 2.5415 11.875H4.4165C4.76168 11.875 5.0415 12.1548 5.0415 12.5C5.0415 12.8452 4.76168 13.125 4.4165 13.125H2.5415C2.19633 13.125 1.9165 12.8452 1.9165 12.5ZM16.2915 12.5C16.2915 12.1548 16.5713 11.875 16.9165 11.875H18.7915C19.1367 11.875 19.4165 12.1548 19.4165 12.5C19.4165 12.8452 19.1367 13.125 18.7915 13.125H16.9165C16.5713 13.125 16.2915 12.8452 16.2915 12.5ZM1.9165 7.5C1.9165 7.15481 2.19633 6.875 2.5415 6.875H4.4165C4.76168 6.875 5.0415 7.15481 5.0415 7.5C5.0415 7.84519 4.76168 8.125 4.4165 8.125H2.5415C2.19633 8.125 1.9165 7.84519 1.9165 7.5ZM16.2915 7.5C16.2915 7.15481 16.5713 6.875 16.9165 6.875H18.7915C19.1367 6.875 19.4165 7.15481 19.4165 7.5C19.4165 7.84519 19.1367 8.125 18.7915 8.125H16.9165C16.5713 8.125 16.2915 7.84519 16.2915 7.5Z"
          fill="#0E35D1"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.9165 3.125C5.19062 3.125 3.7915 4.52411 3.7915 6.25V13.75C3.7915 15.4759 5.19062 16.875 6.9165 16.875H14.4165C16.1424 16.875 17.5415 15.4759 17.5415 13.75V6.25C17.5415 4.52411 16.1424 3.125 14.4165 3.125H6.9165ZM8.1665 5.625C7.13094 5.625 6.2915 6.46444 6.2915 7.5V12.5C6.2915 13.5356 7.13094 14.375 8.1665 14.375H13.1665C14.2021 14.375 15.0415 13.5356 15.0415 12.5V7.5C15.0415 6.46444 14.2021 5.625 13.1665 5.625H8.1665Z"
          fill="#0E35D1"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.5415 7.5C7.5415 7.15481 7.82132 6.875 8.1665 6.875H13.1665C13.5117 6.875 13.7915 7.15481 13.7915 7.5V12.5C13.7915 12.8452 13.5117 13.125 13.1665 13.125H8.1665C7.82132 13.125 7.5415 12.8452 7.5415 12.5V7.5Z"
          fill="#0E35D1"
        />
      </svg>
    ),
  },
  {
    title: 'Coming soon!',
    list: [
      '· Health insurance',
      '· Accident & protection insurance',
      '· Equipment insurance',
      '· etc.',
    ],

    icon: (
      <svg
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.02938 4.96029C7.41225 4.03683 9.0725 3.6214 10.7272 3.78479C12.3821 3.94819 13.929 4.68029 15.1045 5.85637C15.7719 6.524 16.3012 7.31663 16.6622 8.18888C17.0232 9.06106 17.2088 9.99588 17.2085 10.9399C17.2079 12.6028 16.6309 14.2139 15.5756 15.499C15.1389 16.0306 14.6317 16.4928 14.0714 16.875H17.8335C18.1787 16.875 18.4585 17.1548 18.4585 17.5C18.4585 17.8452 18.1787 18.125 17.8335 18.125H10.0262C10.0228 18.125 10.0194 18.125 10.016 18.125H2.8335C2.48832 18.125 2.2085 17.8452 2.2085 17.5C2.2085 17.1548 2.48832 16.875 2.8335 16.875H5.97052C4.81968 16.0899 3.91683 14.9836 3.37983 13.6861C2.74393 12.1497 2.66043 10.4403 3.14355 8.84919C3.62668 7.25813 4.64655 5.88375 6.02938 4.96029ZM10.9585 7.5C10.9585 7.15481 10.6787 6.875 10.3335 6.875C9.98831 6.875 9.7085 7.15481 9.7085 7.5V10.9911L7.39156 13.3081C7.1475 13.5521 7.1475 13.9479 7.39156 14.1919C7.63562 14.436 8.03137 14.436 8.27543 14.1919L10.7754 11.6919C10.8976 11.5698 10.9586 11.4097 10.9585 11.2496V7.5Z"
          fill="#333333"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.93812 2.48894C7.084 2.80178 6.94868 3.17364 6.63581 3.31952C5.33718 3.92509 4.20712 4.84032 3.34494 5.98481C3.13725 6.26051 2.74538 6.31563 2.46967 6.10794C2.19397 5.90025 2.13885 5.50838 2.34654 5.23268C3.33189 3.9247 4.62338 2.87872 6.10755 2.18663C6.42039 2.04076 6.79225 2.1761 6.93812 2.48894ZM13.7296 2.48894C13.5837 2.80178 13.7191 3.17364 14.0319 3.31952C15.3308 3.92519 16.461 4.84062 17.3232 5.98535C17.5309 6.26107 17.9228 6.3162 18.1985 6.10855C18.4742 5.90088 18.5294 5.50902 18.3217 5.2333C17.3363 3.92503 16.0446 2.87883 14.5602 2.18663C14.2474 2.04076 13.8755 2.1761 13.7296 2.48894Z"
          fill="#333333"
        />
      </svg>
    ),
  },
];

export const ProductsSection = () => {
  return (
    <div className="py-8 px-4 md:py-24 lg:px-0">
      <div className="container">
        <h2>Our products</h2>

        <div className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-2 lg:mt-10 lg:grid-cols-3 lg:gap-10">
          {products.map((product) => (
            <motion.div
              key={product.title}
              className="space-y-4 rounded-3xl bg-gray-100 p-4 lg:p-10"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{
                opacity: 1,
                scale: 1,
                transition: { duration: 0.5, delay: 0.5 },
              }}
              viewport={{ once: true }}
            >
              <span className="flex h-14 w-14 items-center justify-center rounded-full bg-indigo-100">
                {product.icon}
              </span>
              <h3 className="text-2xl font-bold">{product.title}</h3>
              {product.description && <p>{product.description}</p>}
              <ul className="space-y-2">
                {product.list?.map((item) => (
                  <li key={item} className="flex items-center">
                    {item}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};
